import { Component, OnInit } from '@angular/core';
import {PlatformLocation } from '@angular/common';
import { ApiService } from '../api.service'
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HeaderComponent } from '../../header/header.component'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  baseUrl: string;
  loginForm: FormGroup;
  isUserLogin:boolean;
  public errorMsg;
  name: boolean

  constructor(
    private api: ApiService,
    private platformLocation: PlatformLocation,
    private fb: FormBuilder,
    private userApi: ApiService,
    private router:Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required,Validators.minLength(1),Validators.maxLength(30), Validators.email]],
      password: ['', Validators.required]
    });

    const newLocal = this.isUserLogin = this.userApi.isLoggedIn();

    // console.log(this.userApi.isLoggedIn());

   }

  ngOnInit(): void {

    this.baseUrl = this.platformLocation['location'].origin;
    
  }

  postdata(loginForm1)
  {
    // console.log(loginForm1);
    this.api.userLogin(loginForm1.value.email,loginForm1.value.password)
    .pipe(first())
    .subscribe(
    data => {
      const redirect = this.userApi.redirectUrl ? this.userApi.redirectUrl : 'user/dashboard/main';
      window.location.href = redirect;
      // this.router.navigate([redirect]);
    },
    error => {
      error => this.errorMsg = error
      this.errorMsg = error
      console.log(error)
    });
  }

  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 1500,
    navText: ['<', '>'],
    autoplay:true,
    animateIn: 'fadeIn', 
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1 
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  }
}